import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  brands: [],
};

const brandSlice = createSlice({
  name: "brands",
  initialState,
  reducers: {
    loadBrands: (state, action) => {
      state.brands = action.payload;
    },
  },
});

export const { loadBrands } = brandSlice.actions;

export const selectBrands = (state) => state.brands.brands;
export default brandSlice.reducer; 